import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getAccountType } from 'mini-campaign-bootstrap/lib/utils/getAccountType';
import { getCampaignIterationCount } from 'mini-campaign/lib/utils/getCampaignIterationCount';
import { getDaysSinceUserSignup } from 'mini-common-utils/lib/utils/getDaysSinceUserSignup';
import { getEndpointType } from 'mini-campaign-bootstrap/lib/utils/getEndpointType';
import { getMailSurfaceRealtimeSignalsFromHost } from './getMailSurfaceRealtimeSignalsFromHost';
import { isIOS } from 'mini-device-utils/lib/utils/isIOS';
import { isModuleActiveUser } from 'mini-campaign-bootstrap/lib/utils/isModuleActiveUser';
import { isModuleEngagedUser } from 'mini-campaign-bootstrap/lib/utils/isModuleEngagedUser';
import { Modules } from 'mini-usercustomproperties';

export const getMailSurfaceIrisRealtimeSignals = async (): Promise<string> => {
    const [
        isEngagedMailUser,
        isActiveSearchUser,
        isActiveCalendarUser,
        isActiveMailUser,
        isActivePeopleUser,
    ] = await Promise.all([
        isModuleEngagedUser(Modules.MAIL),
        isModuleActiveUser(Modules.SEARCH),
        isModuleActiveUser(Modules.CALENDAR),
        isModuleActiveUser(Modules.MAIL),
        isModuleActiveUser(Modules.PEOPLE),
    ]);

    const isConsumerAccount: number = isConsumer() ? 1 : 0;
    const diffInDays = getDaysSinceUserSignup();
    const isNewUser = () => {
        if (isConsumerAccount) {
            return diffInDays === 0 ? 1 : 0;
        }
        //Enterprise Account
        return diffInDays < 30 ? 1 : 0;
    };

    const hostSignals = await getMailSurfaceRealtimeSignalsFromHost();

    const isIOSDevice = isIOS() ? 1 : 0;

    return (
        'ISENGAGEDMAILUSER=' +
        isEngagedMailUser +
        '&ISACTIVESEARCHUSER=' +
        isActiveSearchUser +
        '&ISACTIVECALENDARUSER=' +
        isActiveCalendarUser +
        '&ISACTIVEMAILUSER=' +
        isActiveMailUser +
        '&ISACTIVEPEOPLEUSER=' +
        isActivePeopleUser +
        '&isNewUser=' +
        isNewUser() +
        '&isConsumerAccount=' +
        isConsumerAccount +
        '&endPoint=' +
        getEndpointType() +
        '&iterationCount=' +
        getCampaignIterationCount() +
        (hostSignals ? '&' + hostSignals : '') +
        '&daysSinceFirstLogin=' +
        diffInDays +
        '&accntType=' +
        getAccountType() +
        '&isIOS=' +
        isIOSDevice
    );
};
